import PieChart from '@/components/UI/Charts/PieChart';
import { randomDataSetsForTDM } from '../../../../utils';

function Charts() {
  return (
    <div>
      <h2 className='font-bold mt-20 mb-5'>Project Finance</h2>
      <div className='container grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2'>
        <div className='relative p-5 h-80 bg-white'>
          <div className='absolute px-5 text-center'>
            <h3 className='text-gray-500 font-bold'>Project Uses</h3>
          </div>
          <PieChart
            labels={['Acquisition', 'Construction', 'Soft', 'Financing', 'Development']}
            datasets={randomDataSetsForTDM(100)}
            chartTitle=''
          />
        </div>
        <div className='relative p-5 h-80 bg-white'>
          <div className='absolute px-5 text-center'>
            <h3 className='text-gray-500 font-bold'>Project Sources</h3>
          </div>
          <PieChart labels={['Peoplestown', 'Dopont', 'Woodlawn', 'Haris', 'Spring']} datasets={randomDataSetsForTDM(100)} chartTitle='' />
        </div>
        <div className='divide-y'>
          <div className='flex justify-between uppercase font-bold rounded-t-md bg-gray-50 p-4 border-l-4 border-green-500'>
            <div>Incentive</div>
            <div>File</div>
          </div>
          <div className='flex justify-between px-4 py-4 bg-white'>
            <div>Opportunity Zone</div>
            <div className='text-secondaryColor-normal underline cursor-pointer'>opportunity.docx</div>
          </div>
          <div className='flex justify-between px-4 py-4 bg-white'>
            <div>State Historic</div>
            <div className='text-secondaryColor-normal underline cursor-pointer'>State Historic.docx</div>
          </div>
          <div className='flex justify-between px-4 py-4 bg-white'>
            <div>Federal Historic</div>
            <div className='text-secondaryColor-normal underline cursor-pointer'>federal historic.docx</div>
          </div>
          <div className='flex justify-between px-4 py-4 bg-white'>
            <div>New Market Tax Credit</div>
            <div className='text-secondaryColor-normal underline cursor-pointer'>nmtc.docx</div>
          </div>
          <div className='flex justify-between px-4 py-4 bg-white rounded-b-md'>
            <div>Qualified Census Tract</div>
            <div className='text-secondaryColor-normal underline cursor-pointer'>qualified census track.docx</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Charts;
